import { render, staticRenderFns } from "./chart-dashboard-list.vue?vue&type=template&id=5d16f712&"
import script from "./chart-dashboard-list.vue?vue&type=script&lang=js&"
export * from "./chart-dashboard-list.vue?vue&type=script&lang=js&"
import style0 from "./chart-dashboard-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports